import { useRecoilState } from 'recoil'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import projectCheckpointsApi from '../projectCheckpoints.api'
import { IProjectCheckpointArtifact } from '../projectCheckpoints.types'
import { useEffect, useMemo } from 'react'
import checkpointsArtifactsAtom from '../checkpointArtifacts.atom'

export const useCheckpointArtifactsState = (checkpointId: string | undefined) => {
  const [state, setState] = useRecoilState(checkpointsArtifactsAtom)

  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (!checkpointId || state.items[checkpointId]) {
      return
    }

    wait(projectCheckpointsApi.getArtifacts(checkpointId), (resp) => {
      if (resp.status === 'success') {
        setState((prev) => ({ ...prev, items: { ...prev.items, [checkpointId]: resp.body } }))
      }
    })
  }, [checkpointId])

  const addItem = (item: IProjectCheckpointArtifact) => {
    if (!checkpointId) return
    setState((prev) => ({ ...prev, items: { ...prev.items, [checkpointId]: [...(prev.items[checkpointId] || []), item] } }))
  }

  const artifactsMap: Record<string, IProjectCheckpointArtifact> = useMemo(
    () => (checkpointId && state.items[checkpointId])?.reduce((map, criterion) => ({ ...map, [criterion.id]: criterion }), {}) || {},
    [state.items, checkpointId]
  )

  const artifactsState = useMemo(() => (checkpointId ? state.items[checkpointId] || [] : []), [state.items, checkpointId])

  return { artifactsState, loading, artifactsMap, addItem }
}
